export default "__VITE_ASSET__D7sucQ$H__"